'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.killWorker = killWorker;

var _highlight = require('highlight.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var workerPool = {};

var prism = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
        var code = _ref2.code,
            language = _ref2.language,
            workerUrl = _ref2.workerUrl,
            id = _ref2.id;
        var worker;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        worker = workerPool[id];


                        if (typeof Worker === 'function' && !worker && typeof workerUrl === 'string') {
                            worker = new Worker(workerUrl);
                            workerPool[id] = worker;
                        }
                        if (typeof workerUrl !== 'string' && worker) {
                            killWorker(id);
                        }

                        if (!worker) {
                            _context.next = 5;
                            break;
                        }

                        return _context.abrupt('return', new _promise2.default(function (resolve) {
                            worker.postMessage({ type: 'highlight', id: id, arguments: [code, language] });
                            worker.onmessage = function (_ref3) {
                                var data = _ref3.data;
                                return resolve(data);
                            };
                        }));

                    case 5:
                        return _context.abrupt('return', (language ? (0, _highlight.highlight)(language, code, true) : (0, _highlight.highlightAuto)(code)).value);

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function prism(_x) {
        return _ref.apply(this, arguments);
    };
}();

function killWorker(id) {
    var worker = workerPool[id];
    if (!worker) return;

    worker.terminate();
    delete workerPool[id];
}

exports.default = prism;


// WEBPACK FOOTER //
// ./~/picidae-transformer-react-render/~/react-code-editor/lib/utils/prism.js